'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Text = function Text(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ['children']);

  if (typeof navigator !== 'undefined' && navigator.product === "ReactNative") {
    try {
      var MyText = require('react-native').Text;
      return _react2.default.createElement(
        MyText,
        props,
        children
      );
    } catch (e) {}
  } else {
    return _react2.default.createElement(
      'div',
      props,
      _react2.default.createElement(
        'span',
        null,
        children
      )
    );
  }
};

exports.default = Text;